"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bill__or__report(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "ccb8df89-6530-491d-92a7-d08cbb8638b9",
    "data-name": "Bill_or_Report_ic_mid",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("line", {
    id: "4d17713c-039e-449c-9341-ad872c961f15",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 134,
    x2: 90,
    y2: 134,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "5fcc210b-0b37-4c75-b302-68103b9e3815",
    "data-name": "<Pfad>",
    x1: 74,
    y1: 134,
    x2: 66,
    y2: 134,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "41ae1070-b1a8-44cb-ab9b-87c891bde935",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 86,
    x2: 90,
    y2: 86,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "d9b92f3e-d51a-4d01-b27d-ae83bd7ade68",
    "data-name": "<Pfad>",
    x1: 74,
    y1: 86,
    x2: 66,
    y2: 86,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "89677124-0fa5-41e9-b4d9-2997d59006b2",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 110,
    x2: 90,
    y2: 110,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "6b5f251d-61fa-403d-a875-222d85e64b72",
    "data-name": "<Pfad>",
    x1: 74,
    y1: 110,
    x2: 66,
    y2: 110,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "4326c31f-bf60-43be-8b69-bf834a953535",
    "data-name": "File_pdf_ic 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e14c9097-1370-41ed-b1d3-cd2e0d60e80f",
    "data-name": "Document_ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114,18H56c-6.63,0-14,7.37-14,14V160a14,14,0,0,0,14,14h80a14,14,0,0,0,14-14V54Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,18V50a4,4,0,0,0,4,4h32",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("title", null, "bill-or-report-mid"), /*#__PURE__*/React.createElement("g", {
    id: "77ad5a6d-ff44-4f45-b230-9579edd05bb4",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("use", {
    id: "8077dc45-6a01-4fe9-a5cb-cd3696d39551",
    "data-name": "Bill_or_Report_ic_mid",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#ccb8df89-6530-491d-92a7-d08cbb8638b9"
  })));
}

var _default = ic_bill__or__report;
exports.default = _default;